import React, { useState } from 'react';
import { Alert, Typography } from '@mui/material';

const SFMessage = ({
    show,
    title,
    description,
    type
}) => {
    if (!show) return;

    return (
        <Alert severity={type}>
            <Typography fontSize={16} color={'inherit'} fontWeight={600}>
                {title}
            </Typography>
            <Typography fontSize={14} color={'inherit'}>
                {description}
            </Typography>
        </Alert>
    );
}

export default SFMessage;
